import React from 'react';

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  const {
    action,
    target,
    method,
    children,
  } = this.props; // eslint-disable-line

  return (
    <form
      action-xhr={action}
      method={method}
      target={target || undefined}
    >
      {children}
    </form>
  );
}

export default renderAmp;
